import robotImage from '/assets/images/robot.svg';

import { RobotContainer, RobotImage } from './Style';


type AnimatedRobotProps = {
  isVisible: boolean;
};

const AnimatedRobot = ({ isVisible }: AnimatedRobotProps) => {
  return isVisible ? (
    <RobotContainer>
      <RobotImage src={robotImage} alt="Animated Robot" />
    </RobotContainer>
  ) : null;
};

export default AnimatedRobot;
